import React from 'react';
import { GenericOption } from '../../../voxel/Forms/VoxelAutocomplete';
import VoxelSelectItem from '../../../voxel/Forms/VoxelSelectItem';

export interface HeadCellSelectOptionProps {
  option: GenericOption;
  state?: any[];
  handleFilterChange: (option: GenericOption, checked: boolean) => void;
}

const HeadCellSelectOption: React.FC<HeadCellSelectOptionProps> = React.memo(
  ({ state, option, handleFilterChange }) => {
    const selected = !!state?.some((o) => o === option.value);

    return (
      <VoxelSelectItem
        active={false}
        onClick={() => handleFilterChange(option, !selected)}
        selected={selected}
      >
        {option.title}
      </VoxelSelectItem>
    );
  }
);

export default HeadCellSelectOption;
